import React, { ComponentType, FC } from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import BnlParentDashboard from '../components/parents/bnl/bnl_parent_dashboard';
import PreDashboardOffers from '../components/utils/PreDashboardOffers';
import PreDashboardRedirect from './PreDashboardRedirect';
import RequireParentAuth from './RequireParentAuth';

interface ParentDashboardRouteProps {
  companyName: string;
  companyAuthToken?: string;
  eventLookupByZipcodeEnabled?: boolean;
}

// What the dashboard is handed from here: the studio props plus the route's
// own props.
type DashboardProps = ParentDashboardRouteProps & RouteComponentProps;

// bnl_parent_dashboard is a legacy connect()-ed class component in plain JS,
// so its inferred props stop at what connect() injects and do not include the
// studio props passed through here. The cast states that contract rather than
// erasing it; retyping the legacy component itself is its own change.
const Dashboard =
  BnlParentDashboard as unknown as ComponentType<DashboardProps>;

// The /dashboard route and the two gates that run ahead of it. Every element
// type in here is declared at module scope, which is the whole point: when
// these were built inside App's render body, each App re-render produced new
// component types and React tore the dashboard down and mounted it again —
// re-running BnlParentDashboard's and DashboardGalleries' mount effects, so
// /api/v2/dashboard and the T&C check were each requested twice per visit.
const ParentDashboardRoute: FC<ParentDashboardRouteProps> = ({
  companyName,
  companyAuthToken,
  eventLookupByZipcodeEnabled,
}) => (
  <Route
    exact
    path="/dashboard"
    render={(routeProps: RouteComponentProps) => (
      <PreDashboardRedirect>
        <PreDashboardOffers {...routeProps}>
          <RequireParentAuth>
            <Dashboard
              {...routeProps}
              companyName={companyName}
              companyAuthToken={companyAuthToken}
              eventLookupByZipcodeEnabled={eventLookupByZipcodeEnabled}
            />
          </RequireParentAuth>
        </PreDashboardOffers>
      </PreDashboardRedirect>
    )}
  />
);

export default ParentDashboardRoute;
